import React from 'react';
import Drawer from "./components/Drawer";
import PropTypes from "prop-types";

const DrawerWrapper = ({ children, drawer, isOpen, onToggleDrawer, title, isFiltered, resetFilters }) => {

  const closeDrawer = () => {
    onToggleDrawer && onToggleDrawer(false);
  };

  return <div className="DrawerWrapper">
    <div className="DrawerWrapper__inner">
      <Drawer isOpen={isOpen} closeDrawer={closeDrawer} title={title} isFiltered={isFiltered} resetFilters={resetFilters}>
        {drawer}
      </Drawer>
      <div className="DrawerWrapper__main">
        {children}
      </div>
    </div>
  </div>;
};

DrawerWrapper.displayName = 'DrawerWrapper';

DrawerWrapper.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onToggleDrawer: PropTypes.func,
  drawer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isFiltered: PropTypes.bool,
  resetFilters: PropTypes.func,
};

export default DrawerWrapper;
